import * as React from 'react';
import { Card, CardContent, Container, Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Video from '../../Video/Video';
import TextEditor from '../../Editor';
import EmailForm from '../Estimation/EmailForm';
import { bucketURL, showEditIconBlue, showEditIconForBg, showEditIconWhite } from '../../../server/constants';
import { PlayCircleFilled } from "@material-ui/icons";
import { GeneralDialog, GenericDialogProps } from "../../dialog";
import { initFalse } from "../../../utils/constants";
import Head from 'next/head';

const useStyles = makeStyles((theme) =>
  createStyles({
    getStarted: {
      textAlign: 'left',
      position: 'relative',
      overflow: 'visible',
      maxWidth: '100%',
      marginLeft: '40px',
      float: 'left',
      [ theme.breakpoints.down('md') ]: {
        marginLeft: '0',
      },
      [ theme.breakpoints.down('sm') ]: {
        maxWidth: '100%',
        width: '100%'
      },
    },
  }),
);

function KaiZenHero(props: any) {
  const classes = useStyles();
  const {
    kaizenTitle,
    kaizenSlogan,
    kaizenSloganDescendantText,
    strategyText,
    strategyDescendantText,
    bgImage,
    videoUrl,
    setOpenDialog,
    isUnderstandDisclaimer,
  } = props;

  const [showPopUp, setPopUp] = React.useState(false);
  const onClick = () => setPopUp(true);
  const dialogProps: GenericDialogProps = {
    'aria-labelledby': 'agent-document-viewer-dialog',
    fullWidth: !initFalse,
    disableBackdropClick: false,
    onBackdropClick: () => setPopUp(false),
    content: (
      <Video className="videoPopup" sectionId={'videoUrl'} videoUrl={videoUrl} light={false}/>
    ),
    onClose: () => setPopUp(false),
    open: showPopUp,
  };

  return (<>
      <Head>
        <script async src={`https://www.googletagmanager.com/gtag/js?id=AW-1032877850`}></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-1032877850');
          `
          }}
        />
      </Head>
    <span className="showEditIconForBg">
      <TextEditor
        bgImage={true} src={`${bucketURL}/${bgImage}`} sectionId={'bgImage'} upperDivClass={showEditIconForBg}
      />

      <div className="heroContent" style={{backgroundImage: `url("${bucketURL}/${bgImage}")`}}>
        <div className="overlay">
        <Container maxWidth="lg">
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <TextEditor
                align="left"
                className="colorOrg"
                sectionId={'kaizenTitle'}
                content={kaizenTitle}
                upperDivClass={showEditIconWhite}
              />
              <TextEditor
                align="left"
                className="textWhite"
                data-aos="fade-up"
                data-aos-duration="1500"
                sectionId={'kaizenSlogan'}
                content={kaizenSlogan}
                upperDivClass={showEditIconWhite}
              />
              <TextEditor
                className="textWhite mb30"
                align="left"
                sectionId={'kaizenSloganDescendantText'}
                content={kaizenSloganDescendantText}
                upperDivClass={showEditIconWhite}
              />
              <span className="videoHeroOne" onClick={onClick} data-aos="fade-up"
                    data-aos-duration="1000">
                    <PlayCircleFilled className="f70 mr15 textWhite"/>
                    <div>
                        <Typography className="textHighLight f16">2 Minute Video</Typography>
                        <Typography className="textWhite f18">Learn about Kai-Zen</Typography>
                    </div>
              </span>
              <GeneralDialog dialogClassName="kaiZenMobile"  {...dialogProps} />
              <Video className="kaiZenHero" sectionId={'videoUrl'} videoUrl={videoUrl} light={false}/>
            </Grid>
            <Grid item xs={12} md={6} lg={6} xl={6}>
                <Card className={classes.getStarted}>
                  <CardContent className="heroCard">
                    <div id="base">
                      <Typography variant="subtitle1" component="strong" className="textHighLight">
                        60 - 100%
                      </Typography>
                      <Typography variant="body2" className="textWhite">
                        More for Retirement
                      </Typography>
                      <div id="chevron">&nbsp;</div>
                    </div>
                    <Typography component="strong" align="left" variant="body1"
                                className="textHighLight floatLeft w100">
                      GET STARTED
                    </Typography>
                    <TextEditor
                      className="floatLeft w100 mb0"
                      variant="h3"
                      align="left"
                      component="strong"
                      color={'primary'}
                      sectionId={'strategyText'}
                      content={strategyText}
                      upperDivClass={showEditIconBlue}
                    />
                    <TextEditor
                      variant="subtitle2"
                      align="left"
                      color={'initial'}
                      className="mb20 floatLeft w100"
                      sectionId={'strategyDescendantText'}
                      content={strategyDescendantText}
                      upperDivClass={showEditIconBlue}
                    />
                    <EmailForm setOpenDialog={setOpenDialog} isUnderstandDisclaimer={isUnderstandDisclaimer}/>
                  </CardContent>
                </Card>
            </Grid>
          </Grid>
        </Container>
        </div>
      </div>
    </span>
    </>
  )
}

export default KaiZenHero;
